import classNames from 'classnames';
import { LANGUAGE_MAP } from 'constant/language';
import { ContractType } from '../utils';
import { SHOP_MAP } from 'constant/shop';

const ContractHeader = ({
  headList,
  contractLang,
  title,
  type,
  storeId,
}: {
  headList: { label: string; value: string }[];
  contractLang: string;
  title: string;
  type: ContractType;
  storeId: number;
}) => {
  const isStoreCopy = type === 'SELL_STORE' || type === 'RECYCLE_STORE';
  const isJpShop = storeId === SHOP_MAP.GINZA || storeId === SHOP_MAP.UMEDA;

  return (
    <div className="flex items-center relative mb-6">
      <div>
        {headList.map(({ label, value }, index) => {
          return (
            <div key={index} className="border-b mb-1">
              <span className="italic w-24 inline-block font-semibold">
                {label}
              </span>
              <span>{value}</span>
            </div>
          );
        })}
      </div>

      <h1
        className={classNames(
          'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
          contractLang === LANGUAGE_MAP.EN ? 'text-[22px]' : '',
        )}
      >
        {title}
      </h1>

      {isStoreCopy && (isJpShop || storeId === SHOP_MAP.HONGKONG) && (
        <div className="absolute right-4 -top-4 border px-4 py-2">
          {contractLang === LANGUAGE_MAP.EN ? 'Consignment method' : '買取方法'}
          : 店頭
        </div>
      )}
    </div>
  );
};

export default ContractHeader;
